export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8655.8458bd4a.jpg";